module.exports = __webpack_public_path__ + "img/warning.b952f057.svg";